export default __webpack_public_path__ + "static/media/mlodz6.5f357707.jpg";